import React from "react";
import "../../styles/about-section.css";

const AboutSection = () => {
  return (
    <section className="about">
      <div className="shape"></div>
      <div className="container">
        <div className="row rev">
          <div className="col-xl-6 col-md-12">
            <div className="about__right">
              <div className="images">
                <img
                  className="img1"
                  src="/images/layouts/about-01.png"
                  alt="About 1"
                />
                <img
                  className="img2"
                  src="/images/layouts/about-02.png"
                  alt="About 2"
                />
                <img
                  className="img3"
                  src="/images/layouts/about-03.png"
                  alt="About 3"
                />
                <img
                  className="img4"
                  src="/images/layouts/about-04.png"
                  alt="About 4"
                />
                <img
                  className="img5"
                  src="/images/layouts/about-05.png"
                  alt="About 5"
                />
              </div>
            </div>
          </div>
          <div className="col-xl-6 col-md-12">
            <div className="block-text">
              <h6 className="sub-heading">
                <span>About us</span>
              </h6>
              <h3 className="heading wow" data-aos="fade-up" data-splitting>
                CVMech NFT - Free Mint But Real Value
              </h3>
              <p className="mb-17">
                CVMech is not just an NFT collection. It is a long term access
                key inside the CVPad ecosystem.
              </p>
              <p className="mb-17">
                Holding CVMech unlocks exclusive benefits, priority access, and
                shared rewards worth over $10,000+ across CVPad and ecosystem
                partners.
              </p>
              <p className="mb-26">
                Each CVMech represents real participation, real contribution,
                and real value for users who grow with the ecosystem from the
                early stage.
              </p>
              <a
                href="https://x.com/CVPad_io/status/1998043438970032360"
                target="_blank"
                rel="noopener noreferrer"
                className="action-btn"
              >
                <span>View Tweet</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
